import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hapticFeedbackStyle } from '@components/helpers/hapticFeedbackFunction';

import { playSound } from '../lib/soundEffect';

const useHapticFeedback = (): void => {
  const location = useLocation();

  useEffect(() => {
    playSound('buttons/proceed');
    hapticFeedbackStyle('heavy');
  }, [location.pathname]);

  useEffect(() => {
    // if (Telegram?.WebApp) {
    //   Telegram.WebApp.ready();
    // }
    const handleGlobalButtonClick = (event: MouseEvent): void => {
      if (
        event.target instanceof HTMLElement &&
        event.target.tagName === 'BUTTON'
      ) {
        playSound('buttons/switch');
        hapticFeedbackStyle('light');
      }
    };
    document.addEventListener('click', handleGlobalButtonClick);

    return (): void => {
      document.removeEventListener('click', handleGlobalButtonClick);
    };
  }, []);
};

export { useHapticFeedback };
